function getFileTypeSlug(value, filtersOptions) {
  const fileTypeName = filtersOptions?.fileTypes?.filters?.find(
    (item) => item.value === value
  )?.label
  const pattern = /\((.*?)\)/
  const match = (fileTypeName || '').match(pattern)

  return match ? match[1] : ''
}

export default getFileTypeSlug
